import { lazy } from 'react'
import { registerEditor, registerPreview } from '../editor-registry.js'

const LazyDatabaseEditor = lazy(() =>
  import('../../ui/DatabaseViewer.js').then(m => ({ default: m.DatabaseEditor }))
)

const LazyDatabaseModifier = lazy(() =>
  import('../../ui/DatabaseViewer.js').then(m => ({ default: m.DatabaseModifier }))
)

// SQLite database files — Editor wrapper with View/Edit toggle
registerEditor({
  family: 'sqlite',
  extensions: ['db', 'sqlite', 'sqlite3'],
  name: 'Database Editor',
  component: LazyDatabaseEditor,
  readOnly: false,  // Supports editing — uses HTTP cell-save, not Yjs
  binaryExtensions: ['db', 'sqlite', 'sqlite3'],
})

// Version preview — Modifier in readonly mode
registerPreview({
  extensions: ['db', 'sqlite', 'sqlite3'],
  name: 'Database Preview',
  component: LazyDatabaseModifier,
})
